import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
} from "@mui/material";
import IconWrapper from "components/IconWrapper";
import close from "assets/images/close.svg";
import TextInput from "components/TextInput";
import "./BulkEditBudgetCapModal.scss";
import CustomButton from "components/Button";
import axios from "axios";
import { useEffect, useState } from "react";
import { createSearchParams } from "react-router-dom";
import { APP_METASEARCH_BUDGET_API_ENDPOINT } from "constants/api_urls";
import { useSnackbar } from "notistack";
import { getUserToken } from "../../../utils/functions/userToken";

const months = [
  { month_name: "JAN", month_index: 1 },
  { month_name: "FEB", month_index: 2 },
  { month_name: "MAR", month_index: 3 },
  { month_name: "APR", month_index: 4 },
  { month_name: "MAY", month_index: 5 },
  { month_name: "JUN", month_index: 6 },
  { month_name: "JUL", month_index: 7 },
  { month_name: "AUG", month_index: 8 },
  { month_name: "SEP", month_index: 9 },
  { month_name: "OCT", month_index: 10 },
  { month_name: "NOV", month_index: 11 },
  { month_name: "DEC", month_index: 12 },
];

const BulkEditBudgetCapModal = ({ open, onClose, selectedRows, onLoadTable, budgetAPIURL = "", currency = "", minBudget = 0 }) => {
  
  const token = getUserToken() || "";
  const API_URL = budgetAPIURL;
  const { enqueueSnackbar } = useSnackbar();
  
  const [payload, setPayload] = useState([]);
  const [budgetByMonth, setBudgetByMonth] = useState({});
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const initialPayload = {
      budget_entity_id: selectedRows,
      month_0: null,
      ...months.reduce((acc, month) => {
        acc[`month_${month.month_index}`] = null;
        return acc;
      }, {})
    };
    setBudgetByMonth({});
    setPayload(initialPayload);
    // eslint-disable-next-line
  }, [selectedRows]);

  const updatePayloadBudget = (month, value) => {
    setPayload(prev => ({
      ...prev,
      budget_entity_id: selectedRows,
      [`month_${month}`]: value ? Number(value) : null
    }));
  };

  const handleApply = async () => {
    setLoading(true);
    try {
        const response = await axios.put(
            `${API_URL}`,
            payload,
            { headers: { Authorization: `Bearer ${token}` } }
          );
        if(response.data?.status === "ERROR"){
          enqueueSnackbar(response.data?.error_message, { variant: "error" });
          return;
        }
        enqueueSnackbar("Budget Updated.", { variant: "success" });
        onLoadTable();
    } catch (error) {
      console.error("Error during API calls:", error);
      enqueueSnackbar("An unexpected error occurred.", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      className="budget-cap-modal-campaign-manager"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: "420px", height: "400px", borderRadius: "10px" } }}
    >
      {loading && (
        <div className="loader-overlay">
          <CircularProgress />
        </div>
      )}
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span className="dialogTitle">Edit Budget - {selectedRows?.length} rows selected</span>
        <span><IconWrapper onClick={onClose} icon={close} /></span>
      </DialogTitle>
      <DialogContent>
        <div className="budget-info">
            Minimum budget required: {minBudget + currency}
          </div>
        <TextInput
          sx={{ width: "140px", marginBottom: "24px", fontSize: "12px", fontFamily: "Inter" }}
          placeholder="Enter value"
          numberUnit={currency}
          onChange={e => {
            const value = e.target.value;
            setBudgetByMonth(prev => ({ ...prev, default: value }));
            updatePayloadBudget(0, value);
          }}
        />
        <div className="budgetSubTitle">MONTHLY BUDGET ({currency})</div>
        <div className="monthsGrid">
          {months.map(month => (
            <div
              key={`month_${month.month_index}_${month.month_name}`}
              className="months"
              style={{ display: "flex", alignItems: "center", marginRight: "24px" }}
            >
              <div className="monthLabel">{month.month_name}</div>
              <TextInput
                sx={{ width: "70px", fontSize: "12px", fontFamily: "Inter" }}
                value={budgetByMonth[`month_${month.month_index}`] || ""}
                onBlur={e => {
                  const value = e.target.value;
                  if (value && Number(value) < 0) {
                    enqueueSnackbar(`Value should be greater than or equal to 0 for ${month.month_name}`, { variant: "error" });
                  }
                }}
                onChange={e => {
                  const value = e.target.value;
                  setBudgetByMonth(prev => ({ ...prev, [`month_${month.month_index}`]: value }));
                  updatePayloadBudget(month.month_index, value);
                }}
                numberUnit=""
              />
            </div>
          ))}
        </div>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "flex-start", marginLeft: "10px", marginBottom: "10px" }}>
        <CustomButton title="Apply" variant="filled" onClick={handleApply} />
        <CustomButton title="Cancel" variant="outlined" onClick={onClose} />
      </DialogActions>
    </Dialog>
  );
};

export default BulkEditBudgetCapModal;
